import React from 'react';
import { InputRadio } from '@/components/shared';
import { type AccountLookupItemResponse } from '@/generated/data.schemas';
import styles from './MoveModal.module.scss';

interface AccountRadioProps {
	account: AccountLookupItemResponse;
	checked: boolean;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * One account in the move-target search results. Modelled on `CustomerRadio`,
 * but styled for the modal rather than the customer selector drawer.
 */
export const AccountRadio: React.FunctionComponent<AccountRadioProps> = ({ account, checked, onChange }) => {
	const secondaryText = [account.accountNo, account.owner].filter(Boolean).join(' - ');

	const label = (
		<span className={styles.accountLabel}>
			<span className={styles.accountName}>{account.accountName}</span>
			{secondaryText && <span className={styles.accountMeta}>{secondaryText}</span>}
		</span>
	);

	return (
		<InputRadio
			className={styles.accountRadio}
			name={'targetAccount'}
			id={`target-account-${account.id}`}
			value={account.id}
			label={label}
			checked={checked}
			onChange={onChange}
		/>
	);
};
